<template>
  <search-wrapper :model="searchParams" @search="search">
    <label-input
      class="control"
      labelWidth="100px"
      label="通用名"
      placeholder="请输入通用名"
      width="330px"
      v-model="drugName"
      prop="drugName"
      :input-attr="{ maxlength: 50 }"
      type="input"
      clearable
    />
    <label-input class="control" label="销售时间" width="435px" prop="dateRange">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :defaultTime="['00:00:00', '23:59:59']"
        valueFormat="yyyy-MM-dd HH:mm:ss"
        align="right"
      ></el-date-picker>
    </label-input>
    <label-input class="control" label="是否补传" width="230px" prop="patchedStatus">
      <el-select v-model="patchedStatus" placeholder="">
        <el-option
          v-for="item in patchedStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>
    <label-input
      class="control"
      label="销售订单号"
      placeholder="请输入销售订单号"
      width="330px"
      v-model="orderId"
      prop="orderId"
      :input-attr="{ maxlength: 50 }"
      type="autocomplete"
      :query-search="queryOrderId"
      clearable
      valueKey="orderId"
    />
    <label-input class="control" label="是否处方药" width="230px" prop="isPrescription">
      <el-select v-model="isPrescription" placeholder="">
        <el-option
          v-for="item in isPrescriptionOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </label-input>

    <!-- <el-button class="search-btn" @click="search">查询</el-button> -->
  </search-wrapper>
</template>

<script>
import dayjs from 'dayjs';
import Fetch from '@/api';
import labelInput from '@/components/global/form/labelInputForSupervision';
import searchWrapper from '@/components/global/form/searchWrapper';

export default {
  name: 'searchBar',
  props: {
    type: {
      type: String
    },
    searchParams: {
      type: Object,
      default: () => ({})
    },
    storeId: {
      type: Number || undefined
    }
  },
  components: {
    labelInput,
    searchWrapper
  },
  computed: {
    drugName: {
      get() {
        return this.searchParams.drugName;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'drugName',
          value: val
        });
      }
    },
    orderId: {
      get() {
        return this.searchParams.orderId;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'orderId',
          value: val
        });
      }
    },
    registrationStatus: {
      get() {
        return this.searchParams.registrationStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'registrationStatus',
          value: val
        });
      }
    },
    isPrescription: {
      get() {
        return this.searchParams.isPrescription;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'isPrescription',
          value: val
        });
      }
    },
    patchedStatus: {
      get() {
        return this.searchParams.patchedStatus;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'patchedStatus',
          value: val
        });
      }
    },
    dateRange: {
      get() {
        return this.searchParams.dateRange;
      },
      set(val) {
        this.$emit('changeSearchParams', {
          key: 'dateRange',
          value: val
        });
      }
    }, // patchedStatus

    patchedStatusOptions() {
      return [
        { label: '全部', value: null },
        { label: '补传', value: '1' },
        { label: '当日上传', value: '0' }
      ];
    },
    isPrescriptionOptions() {
      return [
        { label: '全部', value: null },
        { label: '处方药', value: 1 },
        { label: '非处方药', value: 0 }
      ];
    },
    registrationStatusOptions() {
      return [
        { label: '全部', value: '' },
        { label: '待登记', value: '0' },
        { label: '已登记', value: '1' },
        { label: '未登记', value: '9' }
      ];
    },

    pickerOptions() {
      return {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              const yesterday = dayjs().subtract(1, 'days');
              picker.$emit('pick', [
                yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          },
          {
            text: '本年',
            onClick(picker) {
              picker.$emit('pick', [
                dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
              ]);
            }
          }
        ]
      };
    }
  },
  methods: {
    search() {
      this.$emit('search');
    },
    queryOrderId(queryString, cb) {
      const { storeId, type } = this;
      const api = type === 'fourClass' ? Fetch.getSupervisionOrderList : Fetch.getSupervisionSpecialOrderList;
      api({ orderId: queryString, storeId, pageNo: 1, pageSize: 30 }).then(({ data }) => {
        cb(data);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  // .control {
  //   margin-right: 16px;
  //   margin-bottom: 10px;
  // }

  // .zy-date-picker {
  //   margin-right: 16px;
  //   margin-bottom: 10px;
  // }

  .search-btn {
    margin-bottom: 10px;
    height: 40px !important;
    width: 80px !important;
    color: #1e8dff !important;
    background: #ffffff !important;
    border: 1px solid #1e8dff !important;
    &:hover {
      background: rgba(68, 184, 91, 0.1) !important;
    }
  }

  /deep/.date-picker {
    border: unset;
    padding-right: 0;
  }
}
</style>
